import { TypeLandEnumValues } from '../contentful-types';
import { Countries } from '../models';

export const countryUrlMap: {
	[key: number]: Countries;
} = {
	0: 'one-cart',
	3: 'oesterreich',
	6: 'vignette-cze',
	7: 'vignette-svn',
	14: 'schweiz',
};

export const countrySupplierMapByLandId: {
	[key in TypeLandEnumValues]: number;
} = {
	'one-cart': 0,
	oesterreich: 3,
	'vignette-cze': 6,
	'vignette-svn': 7,
	schweiz: 14,
};

export const isoCodeByLandId: {
	[key in TypeLandEnumValues]: string;
} = {
	'one-cart': '0',
	oesterreich: 'aut',
	'vignette-cze': 'cze',
	'vignette-svn': 'svn',
	schweiz: 'ch',
};
